import getRandomNumberByDigit from '@/utils/getRandomNumberByDigit'
import RICH88EGAMEActions from './RICH88EGAMEActions'

export default class RICH88SLOTActions extends RICH88EGAMEActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameCode: 'RICH88-SLOT-001',
      platform: 'RICH88',
    }

    this.gameName = 'GEM Planet'
    this.roundIdSuffix = getRandomNumberByDigit(6)
  }
}
